<template>
  <section class="container">
    <slot></slot>
  </section>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// src/pages/forms/MinorNote.vue